import { Component, ElementRef, OnInit, OnDestroy, OnChanges, AfterViewInit, EventEmitter, Output, Input, Inject, ComponentRef } from '@angular/core';
import { Http } from '@angular/http';

declare var tinymce: any;

@Component({
  selector: 'tinymce-editor',
  template: `
            <div id="tinyFormGroup" class="form-group">
                <div class="hidden">
                    <textarea id="baseTextArea">{{ htmlContent }}</textarea>
                </div>
            </div>`
})
export class TinymceEditorComponent implements OnDestroy, AfterViewInit {
  private elementRef: ElementRef;
  private elementID: string;
  private htmlContent: string;
  private isAlreadyChange: boolean;

  //@Input() ngModel: string;
  @Input()
  set MceHtmlInput(content: string) {
    this.htmlContent = content;
    console.log(content);
    if (tinymce.get(this.elementID) && !this.isAlreadyChange && content) {
      tinymce.get(this.elementID).setContent(content);
      this.isAlreadyChange = true;
    }
  }

  @Output() MceHtmlOutput = new EventEmitter();

  // ngOnChanges(change) {
  //   this.htmlContent = change.ngModel.currentValue;
  //   if (tinymce.get(this.elementID))
  //     tinymce.get(this.elementID).setContent(this.htmlContent);
  // }

  constructor( @Inject(ElementRef) elementRef: ElementRef) {
    this.elementRef = elementRef;

    var randLetter = String.fromCharCode(65 + Math.floor(Math.random() * 26));
    var uniqid = randLetter + Date.now();

    this.elementID = 'tinymce' + uniqid;
    this.MceHtmlOutput = new EventEmitter();
  }

  ngAfterViewInit() {
    //Clone base textarea
    var baseTextArea = this.elementRef.nativeElement.querySelector("#baseTextArea");
    var clonedTextArea = baseTextArea.cloneNode(true);
    clonedTextArea.id = this.elementID;

    var formGroup = this.elementRef.nativeElement.querySelector("#tinyFormGroup");
    formGroup.appendChild(clonedTextArea);

    //Attach tinyMCE to cloned textarea
    tinymce.init(
      {
        cleanup_on_startup: false,
        trim_span_elements: false,
        verify_html: false,
        cleanup: false,
        convert_urls: false,
        relative_urls: false,
        mode: 'exact',
        height: 500,
        theme: 'modern',
        plugins: [
          'table paste code link image'
        ],
        menu: {
          //file: { title: 'File', items: 'newdocument' },
          edit: { title: 'Edit', items: 'cut copy paste' },
          //view: { title: 'View', items: 'visualaid' },
          //format: { title: 'Format', items: 'bold italic underline strikethrough superscript subscript | formats | removeformat' },
          table: { title: 'Table', items: 'inserttable tableprops deletetable | cell row column' },
          tools: { title: 'Tools', items: 'code' }
        },
        toolbar: 'undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image',
        elements: this.elementID,
        setup: this.tinyMCESetup.bind(this)
      }
    );
  }

  ngOnDestroy() {
    //destroy cloned elements
    tinymce.get(this.elementID).remove();
    var elem = document.getElementById(this.elementID);
    if (elem && elem.parentElement)
      elem.parentElement.removeChild(elem);
  }


  tinyMCESetup(ed: any) {
    ed.on('KeyUp', this.tinyMCEOnKeyup.bind(this));
    ed.on('ExecCommand', this.tinyMCEOnKeyup.bind(this));
    ed.on('Change', this.tinyMCEOnKeyup.bind(this));
    ed.on('Paste', this.tinyMCEOnKeyup.bind(this));
  }

  tinyMCEOnKeyup(e: any) {
    let content = tinymce.get(this.elementID).getContent();
    //console.log(content);
    this.MceHtmlOutput.emit(content);
  }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/plugins/tinymce/editor.component.ts